<template>
    <rkm-modal
        :title="readonly ? 'Dados da aplicação' : (index !== null ? 'Edição de aplicação' : 'Nova aplicação')"
        extra-large
        ref="RkmModal"
    >
        <rkm-form
            v-if="model"
            :show-legend="readonly ? false : true"
            ref="RkmForm"
        >
            <template v-if="readonly">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input
                            :value="local.unidadeNomeFantasia"
                            disabled
                            label="Unidade"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-input
                            :value="local.salaVacinacaoNome"
                            disabled
                            label="Sala de vacinação"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col :cols="additionals.salaVacinacaoLogada.criaFichaAb ? 9 : 5">
                        <rkm-form-input
                            :value="local.aplicador.cidadaoCns ? `${this.formatCns(local.aplicador.cidadaoCns)} - ${local.aplicador.cidadaoNome}` : `${local.aplicador.cidadaoNome}`"
                            disabled
                            label="Aplicador"
                        />
                    </rkm-col>

                    <rkm-col
                        v-if="!additionals.salaVacinacaoLogada.criaFichaAb"
                        cols="4"
                    >
                        <rkm-form-input
                            disabled
                            label="CBO"
                            :value="local.ocupacaoNome"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            :value="local.dataRegistro"
                            disabled
                            label="Data"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row
                    v-if="additionals.salaVacinacaoLogada.criaFichaAb"
                >
                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Ocupação"
                            :value="local.ocupacaoNome"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Equipe"
                            :value="local.equipeNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="Turno"
                            :value="local.turnoNome"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Local de atendimento"
                            :value="local.localAtendimentoNome"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="8">
                        <rkm-form-input
                            :value="inputVacinaValue"
                            disabled
                            label="Vacina"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :value="`${local.lote.lote} - Val: ${others.moment(local.lote.dataValidadeLote).format('DD/MM/YYYY')}`"
                            disabled
                            label="Lote"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="local.produtorNome"
                            disabled
                            label="Produtor"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="local.grupoAtendimentoNome"
                            disabled
                            label="Grupo de atendimento"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="local.doseNome"
                            disabled
                            label="Dose"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="local.estrategiaNome"
                            disabled
                            label="Estratégia"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input
                            :value="local.cid.id && `${local.cid.codigo} - ${local.cid.nome}`"
                            disabled
                            label="Motivo de indicação (CID 10)"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-checkbox
                            :checked="!!local.comunicanteHanseniase"
                            disabled
                            inline
                        >
                            Comunicante de Hanseníase
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            :checked="!!local.gestante"
                            disabled
                            inline
                        >
                            Gestante
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            :checked="!!local.puerpera"
                            disabled
                            inline
                        >
                            Puerpera
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            :checked="!!local.imunizacaoAdvertida"
                            disabled
                            inline
                        >
                            Imunização advertida
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            :checked="!!local.viajante"
                            disabled
                            inline
                        >
                            Viajante
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :value="local.observacao"
                            label="Observação"
                            readonly
                            rows="4"
                        />
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-else>
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="additionals && additionals.salaVacinacaoLogada && !additionals.salaVacinacaoLogada.responsavel"
                            :options="form.unidades"
                            :validations="validations.unidadeId"
                            @change="handleUnidadeIdDeChange"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="local.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!local.unidadeId || (additionals && additionals.salaVacinacaoLogada && !additionals.salaVacinacaoLogada.responsavel)"
                            :options="form.salasVacinacao"
                            :validations="validations.salaVacinacaoId"
                            @change="handleSalaVacinacaoIdChange"
                            label="Sala de vacinação"
                            show-default-option
                            text-field="nome"
                            v-model="local.salaVacinacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col :cols="additionals.salaVacinacaoLogada.criaFichaAb ? 9 : 5">
                        <rkm-form-input-autocomplete
                            :disabled="disableAplicador || !local.salaVacinacaoId"
                            :repository="repositories.usuario"
                            :request-query-string-params="{
                                aplicador: true,
                                sala_vacinacao_id: local.salaVacinacaoId,
                                    not_in: [
                                    this.model.cidadaoCns = this.getOnlyDigits(this.model.cidadaoCns),
                                ],
                             }"
                            :search-fields="fields.autocomplete.aplicador"
                            :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                            :validations="validations.aplicador"
                            label="Aplicador"
                            v-model="local.aplicador"
                        />
                    </rkm-col>

                    <rkm-col
                        v-if="!additionals.salaVacinacaoLogada.criaFichaAb"
                        cols="4"
                    >
                        <rkm-form-select
                            :disabled="!local.aplicador"
                            label="CBO"
                            :options="form.ocupacoes"
                            v-model="local.ocupacaoId"
                            :validations="validations.ocupacao"
                            text-field="codigoNome"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            :disabled="disableData || !local.salaVacinacaoId"
                            :max-date="others.moment(additionals.dataAtual, 'YYYY-MM-DD').format('DD/MM/YYYY')"
                            :min-date="minDate"
                            :validations="validations.dataRegistro"
                            label="Data"
                            v-model="local.dataRegistro"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row
                    v-if="additionals.salaVacinacaoLogada.criaFichaAb"
                >
                    <rkm-col>
                        <rkm-form-select
                            label="Ocupação"
                            :options="form.ocupacoes"
                            v-model="local.ocupacaoId"
                            :validations="validations.ocupacao"
                            text-field="codigoNome"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Equipe"
                            :options="form.equipes"
                            v-model="local.equipeId"
                            :validations="validations.equipe"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            label="Turno"
                            :options="form.turnos"
                            v-model="local.turnoId"
                            :validations="validations.turno"
                            text-field="nome"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="form.locais"
                            v-model="local.localAtendimentoId"
                            :validations="validations.localAtendimento"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            default-option-text="Selecione"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="8">
                        <rkm-form-input-autocomplete
                            :disabled="!local.salaVacinacaoId || aprazamento"
                            :repository="repositories.vacina"
                            :request-query-string-params="{origem: 'aplicacao', registro: true, sala_vacinacao_id: local.salaVacinacaoId, possui_saldo_estoque: true}"
                            :search-fields="fields.autocomplete.vacina"
                            :text-field="item => item.id ? `${autocompleteTextField(item)}` : item.nome"
                            :validations="validations.vacina"
                            @input="handleVacinaInput"
                            @select="handleVacinaSelect"
                            label="Vacina"
                            v-model="local.vacina"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!local.vacina"
                            :options="form.lotes"
                            :validations="validations.lote"
                            @change="handleLoteChange"
                            label="Lote"
                            show-default-option
                            v-model="local.lote"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="!local.lote"
                            :options="form.produtores"
                            :validations="validations.produtorId"
                            label="Produtor"
                            show-default-option
                            text-field="nome"
                            v-model="local.produtorId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="!local.vacina"
                            :options="form.estrategias"
                            :validations="validations.estrategiaId"
                            label="Estratégia"
                            @change="handleEstrategiaChange"
                            show-default-option
                            text-field="nome"
                            v-model="local.estrategiaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="!local.estrategiaId"
                            :options="form.doses"
                            :validations="validations.doseId"
                            label="Dose"
                            show-default-option
                            text-field="nome"
                            v-model="local.doseId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disabledGrupoAtendimento"
                            :options="form.gruposAtendimento"
                            :validations="validations.grupoAtendimentoId"
                            label="Grupo de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="local.grupoAtendimentoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cid"
                            :results-limit= "20"
                            :search-fields="fields.autocomplete.cid"
                            :text-field="(item) => item.id && `${item.codigo} - ${item.nome}`"
                            :validations="validations.cid"
                            label="Motivo de indicação (CID 10)"
                            v-model="local.cid"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="8">
                        <rkm-form-checkbox
                            :disabled="disabledcomunicanteHanseniase"
                            inline
                            v-model="local.comunicanteHanseniase"
                        >
                            Comunicante de Hanseníase
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            :disabled="model.sexoId === enums.sexo.MASCULINO"
                            inline
                            v-model="local.gestante"
                        >
                            Gestante
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            :disabled="disabledPuerpera"
                            inline
                            v-model="local.puerpera"
                        >
                            Puerpera
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            inline
                            v-model="local.imunizacaoAdvertida"
                        >
                            Imunização advertida
                        </rkm-form-checkbox>

                        <rkm-form-checkbox
                            :disabled="disabledViajante"
                            inline
                            v-model="local.viajante"
                        >
                            Viajante
                        </rkm-form-checkbox>
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-textarea
                            :validations="validations.observacao"
                            label="Observação"
                            rows="4"
                            v-model="local.observacao"
                        />
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-form>

        <rkm-row>
            <rkm-col>
                <rkm-table
                    :fields="fields.registro"
                    :items="Array.isArray(model.registros) ? model.registros.filter(registro => registro.id == null && registro.registroTipo == 'aplicacao') : []"
                    hide-pagination
                    hide-filters
                >
                    <template v-slot:cell(registroTipo)="{ item }">
                        <template v-if="item.registroTipo === 'aplicacao'">Aplicação</template>
                        <template v-else>Atualização</template>
                    </template>

                </rkm-table>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                v-if="!readonly"
                :disabled="!!loading"
                @click="include"
                color="primary"
            >
                {{ local.id != null ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import estrategia from '@/enums/imunizacao/estrategia'
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import sexo from '@/enums/cadastro/cidadao/sexo'
import vacina from '@/enums/cadastro/vacina'
import turno from '@/enums/geral/turno'
import localAtendimento from '@/enums/atencao-basica/marcador-consumo-alimentar/localAtendimento'

// Mixins.
import { error, formats, repository, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            const autocomplete = {
                aplicador: [
                    {key: 'cadastroCidadao.nome', searchable: true},
                ],
                vacina: [],
                cid: [
                    {key: 'codigo', searchable: true},
                    {key: 'nome', searchable: true},
                ],
            }

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    autocomplete.vacina.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    autocomplete.vacina.push({ key: 'sigla', searchable: true })
                    break;

                    case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    autocomplete.vacina.push({ key: 'sigla', searchable: true })
                    autocomplete.vacina.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    autocomplete.vacina.push({ key: 'sigla', searchable: true })
                    autocomplete.vacina.push({ key: 'abreviacao', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.vacina.push({ key: 'abreviacao', searchable: true })
                    autocomplete.vacina.push({ key: 'nome', searchable: true })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    autocomplete.vacina.push({ key: 'sigla', searchable: true })
                    autocomplete.vacina.push({ key: 'abreviacao', searchable: true })
                    autocomplete.vacina.push({ key: 'nome', searchable: true })
                    break;

                default:
                    autocomplete.vacina.push({ key: 'nome', searchable: true })
                    break;
            }

            const commonFields = []

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    commonFields.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    commonFields.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            return {
                autocomplete,
                registro: [
                    { key: 'registroTipo', label: 'Tipo de registro' },
                    ...commonFields,
                    { key: 'doseNome', label: 'Dose' },
                    {
                        key: 'dataRegistro',
                        label: 'Data',
                        formatter: (value) => {
                            return value ? value.split('-').reverse().join('/') : '';
                        }
                    },
                    { key: 'unidadeNomeFantasia', label: 'Unidade' },
                    { key: 'salaVacinacaoNome', label: 'Sala de vacinação' },
                    { key: 'observacao', label: 'Observação' },
                ],
            }
        },
        minDate() {

            return this.additionals.parametrizacao
                ? this.additionals.parametrizacao.aplicacaoDataRetroativa
                    ? this.model.cidadaoDataNascimento ? this.others.moment(this.model.cidadaoDataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
                    : this.others.moment(this.additionals.dataAtual, 'YYYY-MM-DD').format('DD/MM/YYYY')
                : ''
        },
        validations() {
            return {
                unidadeId: { required: true },
                salaVacinacaoId: { required: true },
                aplicador: { required: true },
                ocupacao: { required: true },
                equipe: { required: true },
                turno: { required: true },
                localAtendimento: { required: true },
                dataRegistro: { required: true },
                vacina: { required: true },
                lote: { required: true },
                produtorId: { required: true },
                grupoAtendimentoId: { required: true },
                doseId: { required: true },
                estrategiaId: { required: true },
                cid: { required: this.local.estrategiaId === this.enums.estrategia.ESPECIAL },
                observacao: { min: 3, max: 5000 },
            }
        },
        inputVacinaValue() {
            let value = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    value = this.local.vacina.abreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    value = this.local.vacina.sigla
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    value = this.local.vacina.siglaNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    value = this.local.vacina.siglaAbreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.local.vacina.abreviacaoNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.local.vacina.siglaAbreviacaoNome
                    break;

                default:
                    value = this.local.vacina.nome
                    break;
            }

            return value
        },
        disabledcomunicanteHanseniase() {
            if (this.local && this.local.vacina && this.local.vacina.id === this.enums.vacina.BCG) {
                return false
            }

            return true
        },
        disabledPuerpera() {
            const salaVacinacao = this.form.salasVacinacao && this.form.salasVacinacao.find(salaVacinacao => salaVacinacao.id === this.local.salaVacinacaoId)

            if (!this.local.salaVacinacaoId) {
                return true
            }
            else if (this.model.sexoId === this.enums.sexo.MASCULINO) {
                return true
            }
            else if (salaVacinacao && !salaVacinacao.criaFichaAb) {
                return true
            }

            return false
        },
        disabledViajante() {
            const salaVacinacao = this.form.salasVacinacao && this.form.salasVacinacao.find(salaVacinacao => salaVacinacao.id === this.local.salaVacinacaoId)

            if (salaVacinacao && !salaVacinacao.criaFichaAb) {
                return true
            }

            return false
        },
        disabledGrupoAtendimento() {
            if(!this.local.salaVacinacaoId) {
                return true
            }
            return false
        },
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid'),
            fichaVacinacao: this.getConectaSusRepository('atencaoBasica.fichaVacinacao'),
            registroVacinacao: this.getConectaSusRepository('imunizacao.registroVacinacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            vacina: this.getConectaSusRepository('cadastro.vacina'),
        }
    },
    data: () => ({
        aprazamento: false,
        enums: {
            estrategia,
            parametrizacaoDescricaoVacina ,
            sexo,
            vacina,
            turno,
            localAtendimento,
        },
        index: null,
        local: {
            unidadeId: null,
            unidadeNomeFantasia: null,
            salaVacinacaoId: null,
            salaVacinacaoNome: null,
            aplicador: null,
            ocupacaoId: null,
            equipeId: null,
            turnoId: null,
            turnoNome: null,
            localAtendimentoId: null,
            localAtendimentoNome: null,
            dataRegistro: null,
            vacina: null,
            lote: null,
            produtorId: null,
            produtorNome: null,
            grupoAtendimentoId: null,
            grupoAtendimentoNome: null,
            doseId: null,
            doseNome: null,
            estrategiaId: null,
            estrategiaNome: null,
            cid: null,
            comunicanteHanseniase: false,
            gestante: false,
            puerpera: false,
            imunizacaoAdvertida: false,
            viajante: false,
            observacao: null,
            aprazamentoId: null,
            statusRia: 'pendente'
        },
        others: { moment },
        readonly: false,
        editing: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getTurno() {
            const now = moment()
            if(now.hour() >= 6 && now.hour() <= 11) {
                return this.enums.turno.MANHA
            }
            if(now.hour() >= 12 && now.hour() <= 17) {
                return this.enums.turno.TARDE
            }
            return this.enums.turno.NOITE
        },
        open(item, readonly = false, aprazamento = false, index = null) {
            this.editing = !!item
            this.resetForm()

            this.aprazamento = aprazamento
            this.readonly = readonly
            this.index = index

            this.local.id = null

            if (item) {
                this.local.id = item.id
                this.local.statusRia = item.statusRia

                if (readonly) {
                    this.local.unidadeNomeFantasia = item.unidadeNomeFantasia
                    this.local.salaVacinacaoNome = item.salaVacinacaoNome
                    this.local.produtorNome = item.produtorNome
                    this.local.grupoAtendimentoNome = item.grupoAtendimentoNome
                    this.local.doseNome = item.doseNome
                    this.local.estrategiaNome = item.estrategiaNome
                    this.local.ocupacaoNome = item.ocupacaoNome
                    this.local.equipeNome =  item.equipeNome
                    this.local.turnoNome = item.turnoNome
                    this.local.localAtendimentoNome = item.localAtendimentoNome
                } else {
                    if (index !== null) {
                        Promise.all([
                            this.getUnidades(),
                            this.getSalasVacinacao(item.unidadeId),
                            this.getLotes(item.salaVacinacaoId, item.vacinaId, item.lote.lote, item.lote.dataValidadeLote),
                            this.getEstrategias(item.vacinaId),
                            this.getDoses(item.vacinaId, item.estrategiaId)
                        ]).then(() => {
                            this.local.unidadeId = item.unidadeId
                            this.local.salaVacinacaoId = item.salaVacinacaoId
                            this.local.produtorId = item.produtorId
                            this.local.produtorNome = item.produtorNome
                            this.local.grupoAtendimentoId = item.grupoAtendimentoId
                            this.local.doseId = item.doseId
                            this.local.estrategiaId = item.estrategiaId
                            this.local.turnoId = item.turnoId
                            this.local.localAtendimentoId = item.localAtendimentoId
                        })
                    }
                    else if (aprazamento) {
                        const salaVacinacaoLogada = this.additionals.salaVacinacaoLogada

                        Promise.all([
                            this.getUnidades(),
                            this.getSalasVacinacao(salaVacinacaoLogada.permiteAplicacao ? salaVacinacaoLogada.unidadeId : null),
                            this.getLotes(salaVacinacaoLogada.id, item.vacinaId),
                            this.getEstrategias(item.vacinaId),
                            this.getDoses(item.vacinaId, item.estrategiaId)
                        ]).then(() => {
                            this.local.doseId = item.doseId
                            this.local.aprazamentoId = item.id
                        })
                    }
                }

                this.local.vacina = {
                    id: item.vacinaId,
                    nome: item.vacinaNome,
                    abreviacao: item.vacinaAbreviacao,
                    sigla: item.vacinaSigla,
                    siglaNome: `${item.vacinaSigla} - ${item.vacinaNome}`,
                    siglaAbreviacao: `${item.vacinaSigla} - ${item.vacinaAbreviacao}`,
                    abreviacaoNome: `${item.vacinaAbreviacao} - ${item.vacinaNome}`,
                    siglaAbreviacaoNome: `${item.vacinaSigla} - ${item.vacinaAbreviacao} - ${item.vacinaNome}`,
                }

                if (aprazamento === false) {
                    this.local.aplicador = {
                        id: item.aplicadorId,
                        cidadaoNome: item.aplicadorNome,
                        cidadaoCns: item.aplicadorCns,
                    }

                    this.$nextTick().then(() => this.local.ocupacaoId = item.ocupacaoId)

                    this.local.dataRegistro = this.others.moment(item.dataRegistro).toDate()
                    this.local.lote = item.lote,
                    this.local.comunicanteHanseniase = !!item.comunicanteHanseniase
                    this.local.gestante = !!item.gestante
                    this.local.puerpera = !!item.puerpera
                    this.local.imunizacaoAdvertida = !!item.imunizacaoAdvertida
                    this.local.viajante = !!item.viajante
                    this.local.observacao = item.observacao
                } else {
                    this.local.dataRegistro = this.others.moment(this.additionals.dataAtual).toDate()
                }

                this.local.cid = {
                    id: item.cidId,
                    codigo: item.cidCodigo,
                    nome: item.cidNome
                }
            } else {
                const salaVacinacaoLogada = this.additionals.salaVacinacaoLogada

                Promise.all([
                    this.getUnidades(),
                    this.getSalasVacinacao(salaVacinacaoLogada.permiteAplicacao ? salaVacinacaoLogada.unidadeId : null),
                    this.getUsuario()
                ]).then(() => {
                    this.local.unidadeId = salaVacinacaoLogada.permiteAplicacao ? salaVacinacaoLogada.unidadeId : null
                    this.local.salaVacinacaoId = salaVacinacaoLogada.permiteAplicacao ? salaVacinacaoLogada.id : null
                    this.local.dataRegistro = this.others.moment(this.additionals.dataAtual).toDate()
                })
            }

            this.$refs.RkmModal.show()
        },
        handleUnidadeIdDeChange(value) {
            this.form.salasVacinacao = null
            this.form.lotes = null
            this.form.produtores = null
            this.local.salaVacinacaoId = null
            this.local.aplicador = null
            this.local.ocupacaoId = null
            this.local.dataRegistro = null
            this.local.lote = null
            this.local.produtorId = null
            this.local.estrategiaId = null
            this.local.cid = null
            this.local.comunicanteHanseniase = false
            this.local.gestante = false
            this.local.puerpera = false
            this.local.viajante = false

            if (this.aprazamento === false) {
                this.form.doses = null
                this.form.estrategias = null
                this.local.vacina = null
                this.local.doseId = null
            }

            if (value) {
                this.getSalasVacinacao(value)
            }
        },
        handleSalaVacinacaoIdChange(value) {
            this.form.lotes = null
            this.form.produtores = null
            this.local.aplicador = null
            this.local.ocupacaoId = null
            this.local.dataRegistro = null
            this.local.lote = null
            this.local.produtorId = null
            this.local.estrategiaId = null
            this.local.cid = null
            this.local.comunicanteHanseniase = false
            this.local.gestante = false
            this.local.puerpera = false
            this.local.viajante = false

            if (this.aprazamento === false) {
                this.form.doses = null
                this.form.estrategias = null
                this.local.vacina = null
                this.local.doseId = null
            }

            if (value && this.aprazamento) {
                this.getLotes(value, this.local.vacina.id)
            }
        },
        handleVacinaInput() {
            this.form.lotes = null
            this.form.produtores = null
            this.local.lote = null
            this.local.produtorId = null
            this.local.estrategiaId = null
            this.local.cid = null
            this.local.comunicanteHanseniase = false

            if (this.aprazamento === false) {
                this.form.doses = null
                this.form.estrategias = null
                this.local.doseId = null
            }
        },
        handleVacinaSelect(value) {
            this.getLotes(this.local.salaVacinacaoId, value.id)
            this.getEstrategias(value.id)

            if (value.id === this.enums.vacina.FLU3V) {
                this.local.cid = {
                    id: this.additionals.cid.id,
                    codigo: this.additionals.cid.codigo,
                    nome: this.additionals.cid.nome,
                }
            }
        },
        handleLoteChange(value) {
            this.form.produtores = null
            this.local.produtorId = null
            this.local.produtorNome = null

            this.getProdutores(this.local.salaVacinacaoId, this.local.vacina.id, value.lote, value.dataValidadeLote)
        },
        handleEstrategiaChange(value) {
            this.local.doseId = null
            this.local.doseNome = null

            this.getDoses(this.local.vacina.id, value)
        },
        getOcupacoes() {
            this.setLoading()

            const request = this.additionals.salaVacinacaoLogada.criaFichaAb
                ? this.repositories.fichaVacinacao.getOcupacoes({
                    usuario_id: this.local.aplicador.id,
                    sala_vacinacao_id: this.local.salaVacinacaoId,
                })
                : this.repositories.registroVacinacao.getOcupacoes({
                    usuario_id: this.local.aplicador.id,
                    sala_vacinacao_id: this.local.salaVacinacaoId,
                })

            request.then(({ data }) => {
                    this.form.ocupacoes = data
                    if(!this.editing && data.length == 1) {
                        this.local.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {
            this.setLoading()
            this.repositories.fichaVacinacao.getEquipes({
                usuario_id: this.local.aplicador.id,
                sala_vacinacao_id: this.local.salaVacinacaoId,
            })
                .then(({ data }) => {
                    this.form.equipes = data
                    if(data.length == 1) {
                        this.local.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async getUnidades() {
            const request = {
                listar: 'unidades',
            }

            this.setLoading()

            try {
                const response = await this.repositories.registroVacinacao.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.unidades = Object.assign(response.data)

                if (this.form.unidades.length === 1) {
                    const selected = this.form.unidades[0]
                    this.local.unidadeId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getSalasVacinacao(unidadeId) {
            const request = {
                listar: 'salas_vacinacao',
                unidadeId: unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.registroVacinacao.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.salasVacinacao = Object.assign(response.data)

                if (this.form.salasVacinacao.length === 1) {
                    const selected = this.form.salasVacinacao[0]
                    this.local.salaVacinacaoId = selected.id

                    if (this.aprazamento) {
                        this.getLotes(selected.id, this.local.vacina.id)
                    }
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUsuario() {
            this.setLoading()
            this.repositories.registroVacinacao.list({
                listar: 'usuario',
                cns: this.getOnlyDigits(this.model.cidadaoCns) ?? null,
            })
                .then(({ data }) => {
                    if(data) {
                        this.local.aplicador = {
                            id: data.id,
                            cidadaoNome: data.cidadaoNome,
                            cidadaoCns: data.cidadaoCns
                        }
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async getLotes(salaVacinacaoId, vacinaId, lote = null, dataValidadeLote = null) {
            const request = {
                listar: 'lotes',
                salaVacinacaoId: salaVacinacaoId,
                vacinaId: vacinaId,
                lote: lote,
                dataValidadeLote: dataValidadeLote,
            }

            this.setLoading()

            try {
                const response = await this.repositories.registroVacinacao.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.lotes = response.data.map(lote => {
                    return {
                        text: `${lote.lote} - Val: ${this.others.moment(lote.dataValidadeLote).format('DD/MM/YYYY')}`,
                        value: lote,
                    }
                })

                if (lote && dataValidadeLote) {
                    const selected = this.form.lotes.find(item => item.value.lote == lote)
                    if(selected) {
                        this.local.lote = selected.value
                    }

                    this.getProdutores(salaVacinacaoId, vacinaId, lote, dataValidadeLote)
                }
                else if (this.form.lotes.length > 0) {
                    const selected = this.form.lotes[0]
                    this.local.lote = selected.value

                    this.getProdutores(salaVacinacaoId, vacinaId, selected.value.lote, selected.value.dataValidadeLote)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getProdutores(salaVacinacaoId, vacinaId, lote, dataValidadeLote) {
            const request = {
                listar: 'produtores',
                salaVacinacaoId: salaVacinacaoId,
                vacinaId: vacinaId,
                lote: lote,
                dataValidadeLote: dataValidadeLote,
            }

            this.setLoading()

            try {
                const response = await this.repositories.registroVacinacao.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.produtores = response.data

                if(this.form.produtores.length === 0) {
                    this.form.produtores = [
                        {
                            id: this.local.produtorId,
                            nome: this.local.produtorNome
                        }
                    ]
                }

                if (this.form.produtores.length === 1) {
                    const selected = this.form.produtores[0]
                    this.local.produtorId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        getDoses(vacinaId, estrategiaId) {
            if(!estrategiaId) return

            const request = {
                origem: 'aplicacao',
                vacina_id: vacinaId,
                estrategia_id: estrategiaId,
            }

            this.setLoading()

            this.repositories.fichaVacinacao.getDoses(request)
                .then(response => {
                    this.form.doses = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEstrategias(vacinaId) {
            const request = {
                origem: 'aplicacao',
                vacina_id: vacinaId,
            }

            this.setLoading()

            this.repositories.fichaVacinacao.getEstrategias(request)
                .then(response => {
                    this.form.estrategias = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        hasAplicacao() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const existe = this.model.registros.find(r => (!r.id || r.id !== this.local.id)
                        && r.vacinaId === this.local.vacina.id
                        && r.doseId === this.local.doseId
                        && r.estrategiaId === this.local.estrategiaId);

                    if (existe) {

                        const dataRegistro = this.others.moment(existe.dataRegistro).format('DD/MM/YYYY')

                        this.showConfirmation(
                            `O paciente já possui um registro idêntico com a mesma vacina, dose e estratégia na
                            data <strong>${dataRegistro}</strong>, com o motivo de
                            <strong>${existe.registroTipo == 'aplicacao' ? 'aplicação' : 'atualização'}</strong>.
                            Deseja realmente continuar?`, async () => { this.$nextTick().then(() => this.handleInclude()) }
                        )

                        return false
                    }

                    this.handleInclude()
            })
        },
        handleInclude() {
            const unidade = this.form.unidades.find(unidade => unidade.id === this.local.unidadeId)
            const salaVacinacao = this.form.salasVacinacao.find(salaVacinacao => salaVacinacao.id === this.local.salaVacinacaoId)
            const produtor = this.form.produtores.find(produtor => produtor.id === this.local.produtorId)
            const grupoAtendimento = this.form.gruposAtendimento.find(grupoAtendimento => grupoAtendimento.id === this.local.grupoAtendimentoId)
            const dose = this.form.doses.find(dose => dose.id === this.local.doseId)
            const estrategia = this.form.estrategias.find(estrategia => estrategia.id === this.local.estrategiaId)
            const ocupacao = this.form.ocupacoes.find(ocupacao => ocupacao.id === this.local.ocupacaoId)
            const equipe = this.form.equipes.find(equipe => equipe.id === this.local.equipeId)
            const turno = this.form.turnos.find(turno => turno.id === this.local.turnoId)
            const locais = this.form.locais.find(locais => locais.id === this.local.localAtendimentoId)

            const aplicacao = {
                unidadeId: unidade.id,
                unidadeNomeFantasia: unidade.nomeFantasia,
                salaVacinacaoId: salaVacinacao.id,
                salaVacinacaoNome: salaVacinacao.nome,
                aplicadorId: this.local.aplicador.id,
                aplicadorNome: this.local.aplicador.cidadaoNome,
                ocupacaoId: this.local?.ocupacaoId,
                ocupacaoNome: ocupacao?.nome,
                equipeId: this.local?.equipeId,
                equipeNome: equipe?.descricao,
                turnoId: this.local?.turnoId,
                turnoNome: turno?.nome,
                localAtendimentoId: this.local.localAtendimentoId,
                localAtendimentoNome: locais?.descricao,
                dataRegistro: this.others.moment(this.local.dataRegistro).format('YYYY-MM-DD'),
                dataCadastro: this.others.moment(this.additionals.dataAtual).format('YYYY-MM-DD'),
                vacinaId: this.local.vacina.id,
                vacinaNome: this.local.vacina.nome,
                vacinaAbreviacao: this.local.vacina.abreviacao,
                vacinaSigla: this.local.vacina.sigla,
                vacinaSiglaNome: `${this.local.vacina.sigla} - ${this.local.vacina.nome}`,
                vacinaSiglaAbreviacao: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao}`,
                vacinaAbreviacaoNome: `${this.local.vacina.abreviacao} - ${this.local.vacina.nome}`,
                vacinaSiglaAbreviacaoNome: `${this.local.vacina.sigla} - ${this.local.vacina.abreviacao} - ${this.local.vacina.nome}`,
                lote: this.local.lote,
                produtorId: produtor?.id,
                produtorNome: produtor?.nome,
                grupoAtendimentoId: grupoAtendimento ? grupoAtendimento.id : null,
                grupoAtendimentoNome: grupoAtendimento ? grupoAtendimento.nome : null,
                doseId: dose.id,
                doseNome: dose.nome,
                estrategiaId: estrategia.id,
                estrategiaNome: estrategia.nome,
                cidId: this.local.cid?.id,
                cidCodigo: this.local.cid?.codigo,
                cidNome: this.local.cid?.nome,
                comunicanteHanseniase: this.local.comunicanteHanseniase,
                gestante: this.local.gestante,
                puerpera: this.local.puerpera,
                imunizacaoAdvertida: this.local.imunizacaoAdvertida,
                viajante: this.local.viajante,
                observacao: this.local.observacao,
                registroTipo: 'aplicacao',
                statusRia: this.local.statusRia,
                alterou: false,
            }

            if (this.index !== null) {
                aplicacao.alterou = true

                if (this.additionals.parametrizacao.usaUltimoFrasco) {
                    this.showConfirmation(
                        'Ultima aplicação do frasco?',
                        async () => {
                            aplicacao.ultimoFrasco = true
                            Object.assign(this.model.registros[this.model.registros.findIndex(r => r.id == this.local.id && r.registroTipo == 'aplicacao')], aplicacao)
                            this.$refs.RkmModal.hide()
                        },
                        async () => {
                            aplicacao.ultimoFrasco = false
                            Object.assign(this.model.registros[this.model.registros.findIndex(r => r.id == this.local.id && r.registroTipo == 'aplicacao')], aplicacao)
                            this.$refs.RkmModal.hide()
                        }
                    )
                } else {
                    aplicacao.ultimoFrasco = false
                    Object.assign(this.model.registros[this.model.registros.findIndex(r => r.id == this.local.id && r.registroTipo == 'aplicacao')], aplicacao)
                    this.$refs.RkmModal.hide()
                }
            } else {

                if (this.aprazamento) {
                    aplicacao.aprazamentoId = this.local.aprazamentoId
                    this.model.aprazamentos.splice(this.model.aprazamentos.findIndex(aprazamento => aprazamento.id === this.local.aprazamentoId), 1)
                }

                if (this.additionals.parametrizacao.usaUltimoFrasco) {

                    this.showConfirmation(
                        'Ultima aplicação do frasco?',
                        async () => {
                            aplicacao.ultimoFrasco = true
                            this.model.registros.push(aplicacao)
                            this.resetVacina()
                        },
                        async () => {
                            aplicacao.ultimoFrasco = false
                            this.model.registros.push(aplicacao)
                            this.resetVacina()
                        }
                    )
                } else {
                    aplicacao.ultimoFrasco = false
                    this.model.registros.push(aplicacao)
                    this.resetVacina()
                }
            }
        },
        resetVacina() {
            this.local.vacina = null
            this.local.lote = null
            this.local.produtorId = null
            this.local.estrategiaId = null
            this.local.doseId = null
            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
        include() {
            this.hasAplicacao()
        },
        resetForm() {
            this.local.unidadeId = null
            this.local.unidadeNomeFantasia = null
            this.local.salaVacinacaoId = null
            this.local.salaVacinacaoNome = null
            this.local.aplicador = null
            this.local.dataRegistro = null
            this.local.ocupacaoId = null
            this.local.equipeId = null
            this.local.turnoId = this.getTurno()
            this.local.localAtendimentoId = this.enums.localAtendimento.UBS
            this.local.vacina = null
            this.local.lote = null
            this.local.produtorId = null
            this.local.produtorNome = null
            this.local.grupoAtendimentoId = null
            this.local.grupoAtendimentoNome = null
            this.local.doseId = null
            this.local.doseNome = null
            this.local.estrategiaId = null
            this.local.estrategiaNome = null
            this.local.cid = null
            this.local.comunicanteHanseniase = false
            this.local.gestante = false
            this.local.puerpera = false
            this.local.imunizacaoAdvertida = false
            this.local.viajante = false
            this.local.observacao = null
            this.local.aprazamentoId = null
            this.local.statusRia = 'pendente'
        },
        autocompleteTextField(item) {
            let textField = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    textField = `${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    textField = `${item.sigla}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    textField = `${item.sigla} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    textField = `${item.sigla} - ${item.abreviacao}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.abreviacao} - ${item.nome}`
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    textField = `${item.sigla} - ${item.abreviacao} - ${item.nome}`
                    break;

                default:
                    textField = `${item.nome}`
                    break;
            }

            return textField
        },
        getOnlyDigits(value) {
            return String(value).replace(/[^\d]/g, '');
        },
    },
    watch: {
        "local.salaVacinacaoId" () {
            if(this.local.salaVacinacaoId) {
                if(this.local.aplicador?.id){
                    this.getOcupacoes()
                    this.getEquipes()
                } else {
                    this.getUsuario()
                }
            }
        },
        "local.aplicador" () {
            this.local.ocupacaoId = null

            if(this.local.aplicador?.id && this.local.salaVacinacaoId) {
                this.getOcupacoes()

                if (this.additionals.salaVacinacaoLogada.criaFichaAb) {
                    this.getEquipes()
                }
            }
        },
        "local.gestante" () {
            if(this.local.gestante) {
                this.local.puerpera = false
            }
        },
        "local.puerpera" () {
            if(this.local.puerpera) {
                this.local.gestante = false
            }
        }
    },
    mixins: [ error, formats, repository, stringCase ],
    props: {
        additionals: { type: Object, required: true },
        disableAplicador: { type: Boolean, default: false },
        disableData: { type: Boolean, default: false },
        form: { type: Object, required: true },
        id: { type: [Number, String], default: null },
        model: { type: Object, required: true },
    },
}
</script>